import React from 'react';
import { IconContext } from 'react-icons';
import { AiOutlineRight } from 'react-icons/ai';

interface INextArrowProps {
  className?: string;
  style?: any;
  onClick?: () => any;
}

const NextArrow: React.FC<INextArrowProps> = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <IconContext.Provider value={{ color: '#242424', size: '12.5px' }}>
        <div className={'icon'}>
          <AiOutlineRight />
        </div>
      </IconContext.Provider>
    </div>
  );
};

export default NextArrow;
